import { ShallowRef, shallowRef } from 'vue';
import { SimpleModal, ModalState } from '@studyportals/modal';
import type { IModalConfig } from '@studyportals/modal';

interface ModalManager {
    open(modal: SimpleModal): void;
    close(modal: SimpleModal): void;
}

interface OwnModal {
    modalContainer: ShallowRef<HTMLDivElement>;
    open(): void;
    close(): void;
}

export const useOwnModal = (
	shouldOpen: () => boolean,
	config: IModalConfig,
): OwnModal => {
	const modalContainer = shallowRef(document.createElement('div'));
	let ownModal: SimpleModal | undefined;

	const getModalManager = (): ModalManager => {
		return window['ModalManager'] as ModalManager;
	};

	const open = (): void => {
		if (!shouldOpen() || ownModal) return;

		ownModal = new SimpleModal(modalContainer.value, config);
		getModalManager().open(ownModal);
	}

	const close = (): void => {
		const modal = ownModal;
		if (!modal) return;

		ownModal = undefined;
		const state = modal.getState();
		if (state === ModalState.OPEN || state === ModalState.VISIBLE) {
			getModalManager().close(modal);
		}
	}

	return { modalContainer, open, close };
}